import { createContext } from "react";

export interface CurrentBranchContextType {
  currentBranch: string;
  favouriteFloor: string | null;
  onUpdateBranch: (id: string) => void;
  onUpdateFavouriteFloor: (id: string | null) => void;
}

export const CurrentBranchContext =
  createContext<CurrentBranchContextType | null>(null);
